var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lockedControl"},[_c('div',{staticClass:"lcTitle"},[_vm._v(_vm._s(_vm.$t('lockedControl.title')))]),_c('div',{staticClass:"lcDesc",domProps:{"innerHTML":_vm._s(_vm.description)}}),_c('font-awesome-icon',{staticClass:"fa-fw fa-3x",attrs:{"icon":_vm.icons.locked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }